import { useState, useEffect, useRef } from 'react';

export function useJustWokeUp(threshold = 10000) {
  const [justWokeUp, setJustWokeUp] = useState(false);
  const lastIntervalTime = useRef(Date.now());

  // Interval that updates the last known time every few seconds
  useEffect(() => {
    const interval = setInterval(() => {
      lastIntervalTime.current = Date.now();
    }, 3000); // heartbeat interval

    return () => clearInterval(interval);
  }, []);

  // Detect if waking up after a gap
  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const now = Date.now();

        if (
          !lastIntervalTime.current ||
          now - lastIntervalTime.current > threshold
        ) {
          setJustWokeUp(true);
        }

        lastIntervalTime.current = now;
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [threshold]);

  // Reset after a short display period
  useEffect(() => {
    if (justWokeUp) {
      const timeout = setTimeout(() => setJustWokeUp(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, [justWokeUp]);

  return justWokeUp;
}
